import { MainTemplate } from "templates/MainTemplate";
import { ListingStayDetailTemplate } from "./ListingStayDetailTemplate";

export default function ListingStayDetailPage() {
  return (
    <MainTemplate>
      <ListingStayDetailTemplate />
    </MainTemplate>
  );
}
